import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { LandingPageSection } from 'src/app/landing-page.model';

@Component({
  selector: 'app-page-how-to',
  templateUrl: './page-how-to.component.html',
  styleUrls: ['./page-how-to.component.scss']
})
export class PageHowToComponent implements OnInit {

  @Input() data: LandingPageSection;
  @Input() desktopWidth: string = "1110";

  trustedHowTo: Array<Record<string, any>> = [];

  constructor(
    private sanitiser: DomSanitizer,
  ) { }

  ngOnInit(): void {
    this.trustedHowTo = this.data.page_how_to.map(h => {
      const newH = h;
      newH.trustedDesc = h.description;
      return newH;
    })
  }

}
